var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import "blocks/RealityCheck/ui/RealityCheck.less";
import { Modal, DialogMessage, DropDown } from "sb-resp-ui";
import { DetailItem, ButtonControl } from "../components";
let RealityCheck = class RealityCheck extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.dataProvider;
    }
    showPopup() {
        const { dict, modalConfig, dialogMessageConfig, intervalOptions, intervalChangeHandler, wageringInformationItemsParams, buttons, isIntervalValid } = this.state;
        return (React.createElement(Modal, { config: modalConfig },
            React.createElement(DialogMessage, { config: dialogMessageConfig },
                React.createElement("div", { className: "rj-dialog-reality-check__details" }, wageringInformationItemsParams.map(params => React.createElement(DetailItem, Object.assign({}, params)))),
                React.createElement("div", { className: `rj-reality-check-dialog__select-wrapper${!isIntervalValid ? " rj-reality-check-dialog__select-wrapper_error" : ""}` },
                    React.createElement(DropDown, { id: "reality-check-dropdown", placeholder: dict.pleaseSelect, data: intervalOptions, hasFilter: false, isNeededMaxZIndex: true, onChangeCallback: intervalChangeHandler })),
                React.createElement("div", { className: "rj-reality-check-dialog__controls" }, buttons.map(item => React.createElement(ButtonControl, Object.assign({ key: item.dataUat }, item)))))));
    }
    render() {
        return (this.state.isOpen && this.showPopup());
    }
};
RealityCheck = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RealityCheck);
export { RealityCheck };
//# sourceMappingURL=RealityCheck.js.map